import { render } from "./testScreen.vue?vue&type=template&id=3bb20a14&scoped=true&ts=true"
import script from "./testScreen.vue?vue&type=script&lang=ts"
export * from "./testScreen.vue?vue&type=script&lang=ts"

import "./testScreen.vue?vue&type=style&index=0&id=3bb20a14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb20a14"]])

export default __exports__